import { useState } from "react";
import { ActionModal } from "../../index";
import clsx from "clsx";
import "./styles.scss";

export interface IExpiredSessionModalProps {
  className: string;
  open: boolean;
  title: string;
  description: string;
  buttonLabel: string;
  onConfirm: () => void;
}

const ExpiredSessionModal = ({
  className,
  open,
  title,
  description,
  buttonLabel,
  onConfirm,
}: IExpiredSessionModalProps) => {
  const [openModal, setOpenModal] = useState(open);

  const onClose = () => setOpenModal(false);
  const onClick = () => {
    onConfirm();
    onClose();
  };

  return (
    <ActionModal
      className={`expired-session-modal ${className}`}
      open={openModal}
      onClose={onClose}
      onClick={onClick}
      buttonLabel={buttonLabel}
      disabled={!open}
    >
      <div
        className={clsx("expired-session-modal-content action-modal-content")}
      >
        <div className={clsx("title")}>{title}</div>
        <div className={clsx("description")}>{description}</div>
      </div>
    </ActionModal>
  );
};

export default ExpiredSessionModal;
